import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';

declare var reviews: any;

@Component({
  selector: 'app-single-review',
  templateUrl: './single-review.component.html',
  styleUrls: ['./single-review.component.scss']
})
export class SingleReviewComponent extends BaseComponent implements OnInit {

  @Input() title: string;
  reviews: any[] = [];
  allReviews: any[] = null;
  @ViewChild("carouselCategoryDiv", {static: false}) carouselCategoryDiv: ElementRef;
  @Output() onWishlistClick = new EventEmitter();
  carouselMarginLeft = 0;
  carouselPosition = 0;
  showMoreDiv = true;
  moreOffersURL = "";
  position: number = 0;
  reviewCount: number = 3;

  constructor() {
    super();

    const reviewsForLanguage = reviews[InternationalizationHelper.getTwoCharactersLanguage()];
    if(reviewsForLanguage) {
      this.allReviews = reviewsForLanguage;
    }
    else {
      this.allReviews = reviews[InternationalizationHelper.defaultLanguage]
    }

    const pickedIndex = [];
    while(pickedIndex.length < this.allReviews.length) {
      const randomIndex = Math.floor(Math.random() * this.allReviews.length);
      if(!pickedIndex.includes(randomIndex)) {
        pickedIndex.push(randomIndex);
        this.reviews.push(this.allReviews[randomIndex]);
      }
    }
  }

  ngOnInit() {
  }

  addToWishlist(item) {
    this.onWishlistClick.emit(item);
  }

  moveRight() {

    const reviewsContainer: any = document.getElementsByClassName('reviews-container')[0];
    const width = reviewsContainer.offsetWidth;
    if(reviewsContainer.scrollBy) {
      reviewsContainer.scrollBy({
        top: 0,
        left: width,
        behavior: 'smooth'
      });
      if(this.position < this.allReviews.length - 1) {
        this.position++;
      }
    }
    
  }

  moveLeft() {

    const reviewsContainer: any = document.getElementsByClassName('reviews-container')[0];
    const width = reviewsContainer.offsetWidth;
    if(reviewsContainer.scrollBy) {
      reviewsContainer.scrollBy({
        top: 0,
        left: -width,
        behavior: 'smooth'
      });
      if(this.position > 0) {
        this.position--;
      }
    }
    
  }

}

